export const GET_ALL_TAGS_SUCCES = 'GET_ALL_TAGS_SUCCESS';
export const GET_ALL_TAGS_FAILED = 'GET_ALL_TAGS_FAILED';
export const GET_ALL_REQUEST = 'GET_ALL_REQUEST';
